export default "__VITE_ASSET__gEiYoMzB__"